import { useState } from 'react';

const faqs = [
  {
    q: '每日爆料的内容来源可靠吗？',
    a: '每日爆料的内容经过编辑团队严格审核，每条爆料都标注了信息来源和可信度评级。我们采用多渠道交叉验证机制，确保发布内容的真实性和准确性。对于未经证实的传闻，会明确标注"待核实"标签。',
  },
  {
    q: '如何下载51每日爆料APP？',
    a: '您可以点击页面中的"下载APP"按钮，根据您的设备选择iOS版或Android版下载。目前APP已在苹果App Store和各大安卓应用市场上线，搜索"51每日爆料"即可找到。APP支持实时推送通知，让您第一时间获取最新爆料。',
  },
  {
    q: '平台访问不了怎么办？',
    a: '由于吃瓜爆料内容的特殊性，部分网络环境可能无法直接访问。您可以关注我们的官方社交媒体账号获取最新地址，或下载每日爆料APP获得更稳定的访问体验。建议收藏本页面作为51每日爆料官网入口。',
  },
  {
    q: '如何向我们投稿爆料？',
    a: '我们非常欢迎用户投稿！您可以通过页面顶部的"爆料投稿"入口或发送邮件至 tougao@meiribaoliao.com 提交您的爆料内容。投稿一经采用，我们将根据内容质量支付稿酬。请确保投稿内容真实、原创。',
  },
  {
    q: '每日爆料是免费的吗？',
    a: '完全免费！每日爆料平台所有内容均免费浏览，APP下载也无需付费。我们致力于为用户提供最快速、最全面的吃瓜爆料资讯，不设置任何付费墙或会员门槛。部分深度专题可能需要注册后阅读。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">常见问题</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">关于每日爆料，你可能想了解的问题都在这里</p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 shrink-0 transition-transform duration-200 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}